import React from 'react';
import Image from 'next/image';
import {Typography, Stack, Button, Link, Grid} from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

import {useStyles} from './login.styles';

interface LoginPageContentTypes {
  authType: string | null;
  msidAuthType: string;
  ohidLoginType: string;
  msidLoginType: string;
  domainName: string;
  loginContent:
    | {
        title: string;
        description1: string;
        link1: string | undefined;
        description2: string;
        employeeLoginLabel: string;
        ohidUserLogin: string;
        homeBanner: string | undefined;
        imgBannerAltText: string | undefined;
        ohidPage?: {
          bannerImage?: string;
        };
      }
    | undefined;
}
export function LoginPage({
  loginContent,
  authType,
  msidAuthType,
  ohidLoginType,
  msidLoginType,
  domainName
}: LoginPageContentTypes) {
  const classes = useStyles();
  const bannerImage = loginContent?.ohidPage?.bannerImage ?? loginContent?.homeBanner ?? '';
  const msidLogin = () => {
    sessionStorage.setItem('loginType', msidLoginType);
    sessionStorage.removeItem('session');
    window.location.href = `/api/auth/login/msid?domain=${domainName}`;
  };
  const ohidLogin = () => {
    sessionStorage.setItem('loginType', ohidLoginType);
    sessionStorage.removeItem('session');
    window.location.href = `/api/auth/login/ohid?domain=${domainName}`;
  };
  const handleLogin = () => {
    if (authType === msidAuthType) {
      msidLogin();
    } else {
      ohidLogin();
    }
  };
  return (
    <Stack direction="row" className={classes.wrapperBox}>
      <Grid className={classes.homeContainer}>
        <Grid className={classes.homeContent}>
          {/* <Typography variant="h1" className={classes.heading1} tabIndex={0}>
            {loginContent?.title}
          </Typography> */}
          <Typography variant="body1" className={classes.description} tabIndex={0}>
            {loginContent?.description1}{' '}
          </Typography>
          {loginContent?.link1 && (
            <Link href={loginContent?.link1 ?? ''} className={classes.link}>
              {loginContent?.link1}
            </Link>
          )}
          {loginContent?.description2 && (
            <Typography variant="body1" className={classes.description2} tabIndex={0}>
              {loginContent?.description2}
            </Typography>
          )}
          <Button
            variant="contained"
            className={classes.signBtn}
            onClick={handleLogin}
            endIcon={<ArrowForwardIcon fontSize="small" />}
          >
            {authType === msidAuthType ? loginContent?.employeeLoginLabel : loginContent?.ohidUserLogin}
          </Button>
        </Grid>
        {bannerImage && (
          <Image
            src={bannerImage}
            alt={loginContent?.imgBannerAltText ?? ''}
            width={450}
            height={400}
            className={classes.bgOverlayImage}
            unoptimized
            priority={false}
          />
        )}
      </Grid>
    </Stack>
  );
}
